// cycle gallery
jQuery.fn["cycleGallery"] = function (options: any) {
  options = jQuery.extend(
    {
      holder: ".holder",
      slider: ".slider",
      slides: "li",
      btnPrev: ".link-prev",
      btnNext: ".link-next",
      pagerLinks: ".pager a",
      curItem: ".cur-item",
      allItems: ".all-items",
      activeClass: "active",
      animSpeed: 650,
      autoRotation: false,
    },
    options
  );

  return this.each((ix: number, el: Element) => {


    const gal = jQuery(el);
    const slider = jQuery(options.slider, gal);
    const slides = jQuery(options.slides, slider);
    const btnPrev = jQuery(options.btnPrev, gal);
    const btnNext = jQuery(options.btnNext, gal);
    const pagerLinks = jQuery(options.pagerLinks, gal);
    const curItem = jQuery(options.curItem, gal);
    const allItems = jQuery(options.allItems, gal);
    const activeClass = options.activeClass;
    const animSpeed = options.animSpeed;
    const autoRotation = options.autoRotation;

    let animating = false;
    const len = slides.length;
    const slideWidth = slides.eq(0).outerWidth(true);
    let index = 0;
    let prevIndex = 0;
    let direction = true,
      timer: ReturnType<typeof setTimeout>;

    slides
      .css({ position: "absolute", left: slideWidth })
      .eq(0)
      .css({ left: 0 })
      .addClass(activeClass);
    slider.css({ position: "relative" }).height(slides.eq(0).outerHeight(true));
    function stopAutoSlide() {
      clearTimeout(timer);
    }
    function autoSlide() {
      clearTimeout(timer);
      if (autoRotation) {
        timer = setTimeout(slideNext, autoRotation + animSpeed);
      }
    }
    function switchSlide() {
      animating = true;
      stopAutoSlide();
      if (direction) {
        slides
          .eq(prevIndex)
          .removeClass(activeClass)
          .stop()
          .animate({ left: -slideWidth }, { duration: animSpeed });
        slides
          .eq(index)
          .addClass(activeClass)
          .css({ left: slideWidth })
          .stop()
          .animate(
            { left: 0 },
            {
              duration: animSpeed,
              complete: function () {
                animating = false;
              },
            }
          );
      } else {
        slides
          .eq(prevIndex)
          .removeClass(activeClass)
          .stop()
          .animate({ left: slideWidth }, { duration: animSpeed });
        slides
          .eq(index)
          .addClass(activeClass)
          .css({ left: -slideWidth })
          .stop()
          .animate(
            { left: 0 },
            {
              duration: animSpeed,
              complete: function () {
                animating = false;
              },
            }
          );
      }
      slider
        .stop()
        .animate(
          { height: slides.eq(index).outerHeight(true) },
          { duration: animSpeed }
        );
      prevIndex = index;
      refresh();
      autoSlide();
    }
    function refresh() {
      const cur =
        index >= 0 ? (index >= len ? 1 : index + 1) : len - Math.abs(index) + 1;
      if (curItem.length) curItem.text(cur);
      if (allItems.length) allItems.text(len);
      if (pagerLinks.length)
        pagerLinks
          .removeClass(activeClass)
          .eq(cur - 1)
          .addClass(activeClass);
    }
    function slideNext() {
      if (!animating) {
        if (index == len - 1) index = 0;
        else index++;
        direction = true;
        switchSlide();
      }
    }
    function slidePrev() {
      if (!animating) {
        if (index == 0) index = len - 1;
        else index--;
        direction = false;
        switchSlide();
      }
    }
    btnNext.click(function () {
      slideNext();
      return false;
    });

    btnPrev.click(function () {
      slidePrev();
      return false;
    });

    pagerLinks.each((ix: number, el: Element) => {
      jQuery(el).click(function (e) {
        e.preventDefault();

        if (!animating && index != ix) {
          index = ix;
          if (index > prevIndex) direction = true;
          else direction = false;
          switchSlide();
        }
      });
    });

    refresh();
    autoSlide();
  });
};


// cycle gallery init
export function initCycleGallery($: JQueryStatic) {
  const gallery = $(".gallery");

  gallery.cycleGallery({
    slider: ".slide-show",
    slides: "li",
    pagerLinks: ".switcher li",
    animSpeed: 650,
    autoRotation: 5000,
  });
}
